import burger from "./modules/burger";
import FixedElementClearance from "./modules/FixedElementClearance";
import MenuToggle from "./modules/MenuToggle";
import slides from "./modules/slides";
import SmoothScroll from "smooth-scroll/dist/smooth-scroll";
import KamiModal from "./modules/KamiModal";
import KamiTabs from "./modules/KamiTabs";
import accordion from "./modules/accordion";
import StickyOnScroll from "./modules/sticky-on-scroll";

export default () => {
    burger();
    slides();
    accordion();

    new KamiModal();

    new KamiTabs();

    new StickyOnScroll(".main-menu");

    new SmoothScroll('a[href*="#"]', { header: ".js-get-main-header-height" });

    new FixedElementClearance({
        element: ".js-get-main-header-height",
        CSSVariableName: "main-header-height",
    });

    new MenuToggle({
        menuToggle: [".js-main-menu-mobile-toggle"],
        menuElement: ".main-menu-mobile",
        menuClose: [".js-close-menu-mobile"],
        activeBodyClass: "mobile-menu-is-open",
        breakpointToHide: 1200,
    });
};
